export default "/dist/files/icone_formalites.32353126111eae1632d3a1e8d7cef794.svg";